var _AuthorizationEntity_instances, _AuthorizationEntity_castSubjectTypeOnSubjectInstance;
import { __classPrivateFieldGet } from "tslib";
import { createMongoAbility, subject } from '@casl/ability';
import { isEmpty, isNil } from 'lodash-es';
function getAbilityFromAuthorizationSubjectActions(input) {
    const actionsWithoutField = input.subjectActions.filter(a => isNil(a.field));
    const actionsWithField = input.subjectActions.filter(a => !isNil(a.field));
    const rules = [];
    const addRule = (action, condition, field, negation) => {
        rules.push({
            action,
            fields: field,
            conditions: condition,
            subject: input.subject.id,
            inverted: negation ?? false
        });
    };
    actionsWithoutField.forEach(p => {
        addRule(p.actionId, p.condition);
        input.subject.protectedFields?.forEach(field => { addRule(p.actionId, p.condition, field, true); });
    });
    actionsWithField.forEach(p => { addRule(p.actionId, p.condition, p.field); });
    const ability = createMongoAbility(rules);
    return ability;
}
export class AuthorizationEntity {
    constructor(subject, authorizedActions) {
        _AuthorizationEntity_instances.add(this);
        this.subject = subject;
        this._ability = getAbilityFromAuthorizationSubjectActions({ subject, subjectActions: authorizedActions });
    }
    get subjectId() {
        return this.subject.id;
    }
    getConditionsForAction(action) {
        const rules = this._ability.rulesFor(action, this.subject.id);
        const conditionsForAction = [];
        for (const rule of rules) {
            if (!isNil(rule.conditions) && !isEmpty(rule.conditions)) {
                conditionsForAction.push(rule.conditions);
            }
        }
        return conditionsForAction.flat();
    }
    can(action, fieldOrSubjectOrSubjectArray, field) {
        if (typeof fieldOrSubjectOrSubjectArray === 'number' ||
            typeof fieldOrSubjectOrSubjectArray === 'symbol' ||
            typeof field === 'number' ||
            typeof field === 'symbol') {
            throw new Error('Invalid argument type received');
        }
        if (typeof fieldOrSubjectOrSubjectArray === 'string' || isNil(fieldOrSubjectOrSubjectArray)) {
            return this._ability.can(action, this.subject.id, fieldOrSubjectOrSubjectArray ?? '*');
        }
        if (Array.isArray(fieldOrSubjectOrSubjectArray)) {
            return fieldOrSubjectOrSubjectArray.every(subjectInstance => this.can(action, subjectInstance, field));
        }
        const effectiveSubjectInstance = __classPrivateFieldGet(this, _AuthorizationEntity_instances, "m", _AuthorizationEntity_castSubjectTypeOnSubjectInstance).call(this, fieldOrSubjectOrSubjectArray);
        return this._ability.can(action, effectiveSubjectInstance, field ?? '*');
    }
}
_AuthorizationEntity_instances = new WeakSet(), _AuthorizationEntity_castSubjectTypeOnSubjectInstance = function _AuthorizationEntity_castSubjectTypeOnSubjectInstance(subjectInstance) {
    try {
        return subject(this.subject.id, subjectInstance);
    }
    catch {
        return subjectInstance;
    }
};
//# sourceMappingURL=base.js.map